var map = {
	"./birthday/1.png": 5233,
	"./birthday/2.png": 1418,
	"./birthday/3.png": 2643,
	"./birthday/4.png": 2476,
	"./birthday/5.png": 1573,
	"./funeral/1.svg": 9461,
	"./religious/1.svg": 1229,
	"./religious/2.png": 3994,
	"./religious/3.png": 4755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5220;